
import { createSelector } from 'reselect'
import _ from 'lodash'
import moment from 'moment'

//const _values = (obj) => Object.keys(obj).map(key => obj[key])
const _keys = (obj) => Object.keys(obj)

const getCounts         = (state: Store) => state.counts
const getRedditMentions = (state: Store) => state.redditMentions
const getRedditMentionsSub = (state: Store) => state.redditMentionsSub
const getCurrentCount   = (state: Store) => state.currentCount
const getCoins          = (state: Store) => state.coins
const getSelectedCoin   = (state: Store) => state.ui.selectedCoin
const getUntilDate      = (state: Store) => state.ui.untilDate
const getTrackedDays    = (state: Store) => state.ui.trackedDays
const getCoinsDataStatus = (state: Store) => state.coinsDataStatus
const getCountsDataStatus = (state: Store) => state.countsDataStatus
const getCurrentCountDataStatus = (state: Store) => state.currentCountDataStatus

const calcBitcointalkDifs = (arr, coin) => {
  const bitcointalkCounts = arr.filter(e => e.platform === 'bitcointalk')


  let resultArr = []

  bitcointalkCounts.forEach((el, i) => {

    if(i !== 0){
      const timeDif = (el.time - bitcointalkCounts[i - 1].time ) / (60 * 60)
      const dif = Math.max(el.bitcointalk - bitcointalkCounts[i - 1].bitcointalk, 0) / timeDif

      resultArr.push({
        ...el,
        bitcointalk: dif > 700 ? 0 : dif
      })
    }
  })
  return arr.filter(e => e.platform !== 'bitcointalk').concat(resultArr)
}

const getDeletedPast = (coin) => {
  const deletedPastRes = {}
  if(!coin.deletedPast) return

  for(let platform in coin.deletedPast){
    deletedPastRes[platform] = {}
    let deletedPast = coin.deletedPast && coin.deletedPast[platform]
    // deletedPast can be like this: 23232323- or -2323232323 or 23232323-23232323 -> so we add 0 or infinity if missing
    if(deletedPast[0] === '-') deletedPast = '0' + deletedPast
    if(deletedPast.slice(-1) === '-') deletedPast = deletedPast + '9999999999'
    const start = deletedPast.split('-')[0]
    const end = deletedPast.split('-')[1]
    deletedPastRes[platform] = { start, end }
  }
  return deletedPastRes
}

const getFollowersData = (
  counts,
  redditMentions,
  redditMentionsSub,
  currentCount,
  coins,
  coinID,
  untilDate,
  trackedDays,
  coinsDataStatus,
  countsDataStatus,
  currentCountDataStatus,
) => {

  if(!_keys(counts).length) return []
  if(
    coinsDataStatus !== 'LOADED' ||
    countsDataStatus !== 'LOADED' ||
    currentCountDataStatus !== 'LOADED'
  ) { return [] }

  // if user has set untilDate to some day in the past
  const inPast = parseInt(untilDate, 10) < parseInt(moment().format('YYYYMMDD'), 10)

  // add currentCounts ( last counts from high-frequeny-fetching ) if untilDate is not set to a date in past
  const _counts = inPast ? counts : { ...counts, ...currentCount }

  const coin = coins.find(c => c.id === coinID)
  const deletedPast = getDeletedPast(coin)

  const countsFormated = []


  for(let time in _counts){
    _keys(_counts[time]).forEach(platform => {

      // coin.skips && coin.skips[platform] && console.log(
      //   coin.skips[platform] + ' ' + time +
      //   coin.skips[platform].includes(time)
      // )

      if(
        (
          deletedPast &&
          deletedPast[platform] &&
          deletedPast[platform] && deletedPast[platform].start <= time && deletedPast[platform].end >= time
        ) ||
        (
          coin.skips &&
          coin.skips[platform] &&
          coin.skips[platform].includes(time)
          // skips looks like: '43434343' or '43434343,4545454545' (unixtimes)
        )
      ){
        // for the rare case, that counts for a certain period should be hidden
      } else {
        countsFormated.push({ time: parseInt(time, 10), [platform]: _counts[time][platform], platform })
      }
    })
  }

  redditMentions.forEach((mention: {doc_count: number, key: number }) => {
    countsFormated.push({
      time: mention.key,
      reddit_m: mention.doc_count,
      platform: 'reddit_m'
    })
  })

  redditMentionsSub.forEach((mention: {doc_count: number, key: number }) => {
    countsFormated.push({
      time: mention.key,
      reddit_ms: mention.doc_count,
      platform: 'reddit_ms'
    })
  })

  const sortedCounts =  _.sortBy(countsFormated, ['platform', 'time'])
  const zipedCounts = thinOutCounts(sortedCounts, trackedDays) // removes for example every second count
  const countsCleaned = calcBitcointalkDifs(zipedCounts, coin)

  return countsCleaned
}

// removes every second or third count to have less data
// the higher the grade, the more data gets removed
// it also avareges out removed data, doesnt just skip it
const thinOutCounts = (counts, trackedDays) => {
  let grade = 0 // default is not to remove any data

  if(trackedDays >= 30) grade = 3

  if(grade === 0) return counts

  const countsR = counts.reverse()
  let currentPlaform = '';
  let slot = 0;
  let thinedCounts = []

  countsR.forEach((count, i) => {
    const prevPlatform = currentPlaform
    currentPlaform = count.platform

    currentPlaform === prevPlatform
      ? slot = (slot === grade) ? 0 : slot + 1
      : slot = 0

    const nextPlatformsAreSame = countsR[i+grade] && countsR[i+grade].platform === currentPlaform
    if(!nextPlatformsAreSame) return thinedCounts.push(count)
    if(slot !== 0) return

    let sum = 0
    for(let j = 0; j<= grade; j++){
      sum += countsR[i+j][currentPlaform]
    }
    const newCount = sum / (grade + 1)

    thinedCounts.push({ ...count, [currentPlaform]: newCount })

  })

  return thinedCounts.reverse()
}



export default createSelector([
  getCounts,
  getRedditMentions,
  getRedditMentionsSub,
  getCurrentCount,
  getCoins,
  getSelectedCoin,
  getUntilDate,
  getTrackedDays,
  getCoinsDataStatus,
  getCountsDataStatus,
  getCurrentCountDataStatus,
], getFollowersData)



// WEBPACK FOOTER //
// ./src/selectors/followersDataOfCoin.js